// Helper function to get image URL with PUBLIC_URL
export const getImageUrl = (imageName) => {
    return `${process.env.PUBLIC_URL}/assets/${imageName}`;
};

// Define all image paths in one place
export const Images = {
    defaultImage1: getImageUrl('defaultimage1.jpg'),
    defaultImage2: getImageUrl('defaultImage2.jpg'),
    defaultImage3: getImageUrl('defaultImage3.jpg'),
    logo: `${process.env.PUBLIC_URL}/Nicer-Lawns-LogoPNGTransparency.png`
};

// Export a CSS variable string that can be used in App.css
export const getCSSImageVars = () => {
    const root = document.documentElement;
    root.style.setProperty('--hero-bg', `url(${Images.defaultImage2})`);
};